import trackingPlanificationEscl from '../locales/es-CL/trackingPlanification.json';
import trackingPlanificationEsmx from '../locales/es-MX/trackingPlanification.json';
import trackingPlanificationEsco from '../locales/es-CO/trackingPlanification.json';
import trackingPlanificationEnus from '../locales/en-US/trackingPlanification.json';
import RouteDetailDeliveryForm from '../components/RouteDetailDeliveryForm.vue';
import RouteDetailMap from '../components/RouteDetailMap.vue';
import RouteDetailMapV2 from '../components/RouteDetailMapV2.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import axios from 'axios';
import showOperationDetail from '../operationDetail/operationDetailHandler';

import moment from 'moment';

export default {
  name: 'TrackingPlanification',
  components: {
    RouteDetailMap,
    RouteDetailMapV2,
    GoogleMapsApiLoader,
    RouteDetailDeliveryForm,
    VueCtkDateTimePicker,
  },
  i18n: {
    messages: {
      'es-CL': {
        trackingPlanification: trackingPlanificationEscl,
      },
      'es-MX': {
        trackingPlanification: trackingPlanificationEsmx,
      },
      'es-CO': {
        trackingPlanification: trackingPlanificationEsco,
      },
      'en-US': {
        trackingPlanification: trackingPlanificationEnus,
      },
    },
  },
  data() {
    return {
      showImages: false,
      gapi: null,
      dataAccess: null,
      isMainPageBussy: false,
      isRouteBussy: false,
      isDetailPhotoBussy: false,
      isDetailActive: false,
      actualDate: null,
      selectedRoute: null,
      operationRoute: [],
      selectedTrip: null, //Esto es un formateo para usarlo en el modal de imagenes
      selectedOperation: null,
      selectedIdCollapse: '',
      planification: [],
      auxRoutesDone: [],
      auxRoutesAssigned: [],
      assignedRoutes: [],
      doneRoutes: [],
      routes: [],
      suggestions: [],
      filteredSuggestions: {
        routes: [],
        vehicles: [],
        drivers: [],
      },
      filter: null,
      actualClicked: -1,
      vehiclesLocation: [],
      filterVehicleLocation: [],
      timeoutID: null,
      countDownId: null,
      autoRefreshTimerLimit: 180,
      actualDateZone: null,
      actualChooseDate: null,
      filterTracking: '',
      useGeoFence: false,
      visibilityGeofence: true,
      vehiclesIds: [],
      refreshCountDown: 0,
      refreshCountDownStart: 10,
      globalStats: {
        totalOps: 0,
        totalOpsDone: 0,
        totalOpsPending: 0,
        totalOpsRejected: 0,
        totalOpsPartially: 0,
        totalOpsFilter: 0,
        totalOpsDoneFilter: 0,
        totalOpsPendingFilter: 0,
        totalOpsRejectedFilter: 0,
        totalOpsPartiallyFilter: 0,
      },
      socket: {},
    };
  },
  async created() {
    await GoogleMapsApiLoader({
      libraries: ['places', 'marker'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.actualDateZone = moment(new Date()).format('YYYY-MM-DD');
    const url = `${this.$store.getters.urlWebSocketRealTimeRoute}?ignorarFiltros=true&at=${this.$store.getters.accessToken}`;
    this.socket = await new WebSocket(url);
    this.socket.onopen = () => {
      console.log('Websocket real time route connected.');
    };
    this.socketOnMessage();
    this.prepareData();
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    async scrollToTop(){
      await this.waitForElm('#topElement');
      // Si quieres desplazar un contenedor específico, por ejemplo con id="myContainer"
      const topElement = document.getElementById('topElement');
      topElement.scrollIntoView({ behavior: 'smooth' });
    },
    /**
     * Metodo para enviar un mensaje por websocket, si el socket esta en un estado diferente a OPEN intentara esperar hasta que le permita enviar el mensaje o tirar un error
     * @param {*} message
     */
    async sendMessage(message) {
      if (this.socket.readyState !== this.socket.OPEN) {
        try {
          await this.waitForOpenConnection(this.socket);
          console.log("Enviando mensaje para escuchar vehículos");
          this.socket.send(message);
        } catch (err) {
          console.error(err);
        }
      } else {
        this.socket.send(message);
      }
    },
    /**
     * Este metodo se utiliza por si al momento de querer enviar el  mensaje, si este falla arroja un error de conexion
     * @returns
     */
    waitForOpenConnection() {
      return new Promise((resolve, reject) => {
        const maxNumberOfAttempts = 10;
        const intervalTime = 200;

        let currentAttempt = 0;
        const interval = setInterval(() => {
          if (currentAttempt > maxNumberOfAttempts - 1) {
            clearInterval(interval);
            reject(new Error('Maximum number of attempts exceeded.'));
          } else if (this.socket.readyState === this.socket.OPEN) {
            clearInterval(interval);
            resolve();
          }
          currentAttempt++;
        }, intervalTime);
      });
    },
    socketOnMessage() {
      this.socket.onmessage = async (event) => {
        // Se hace un parse de la data que llega a formato JSON
        let parsedMessage = JSON.parse(event.data);
        // Si los mensajes son distintos a undefined guarda la ubicacion entrante
        if (typeof parsedMessage !== 'undefined') {
          let pointSort = parsedMessage.data.sort((a, b) => a.gpsData.utc - b.gpsData.utc);
          pointSort.forEach((point) => {
            let vehicleOnList = this.vehiclesLocation.find((veh)=> veh.vehicleId == point.vehicleId);
            const gpsData = point.gpsData;
            this.validAppVersion(gpsData);
            if(vehicleOnList){
              if(vehicleOnList.emitedPoint < gpsData.utc && point.lat != 0 && point.lon != 0){
                vehicleOnList.lat = point.lat;
                vehicleOnList.lon = point.lon;
                vehicleOnList.emitedPoint = gpsData.utc;
                vehicleOnList.gpsData.cog = gpsData.cog;
                vehicleOnList.gpsData.appVersion = gpsData.adc >= 0  &&  gpsData.adc2 >= 0 &&  gpsData.adc3 >= 0 ? `${gpsData.adc}.${gpsData.adc2}.${gpsData.adc3}` : "1.0.0";
                vehicleOnList.gpsData.battery = gpsData.bateria != null &&  gpsData.bateria != undefined && gpsData.bateria >= 0 ? (gpsData.bateria*100)/50 : 0;                
                vehicleOnList.gpsData.signal = gpsData.adc4 != null &&  gpsData.adc4 != undefined ? gpsData.adc4 : 0;
              }
            }else{
              if(gpsData.utc && point.lat != 0 && point.lon != 0){
                this.vehiclesLocation.push({
                  vehicleId:  point.vehicleId,
                  plate: point.plate,
                  lat: point.lat,
                  lon: point.lon,
                  emitedPoint:  gpsData.utc,
                  gpsData: {
                    cog: gpsData ? gpsData.cog : 0,
                    appVersion: gpsData.adc >= 0 &&  gpsData.adc2 >= 0 &&  gpsData.adc3 >= 0 ? `${gpsData.adc}.${gpsData.adc2}.${gpsData.adc3}` : "1.0.0",
                    battery: gpsData.bateria != null &&  gpsData.bateria != undefined && gpsData.bateria >= 0 ? (gpsData.bateria*100)/50 : 0,              
                    signal: gpsData.adc4 != null &&  gpsData.adc4 != undefined ? gpsData.adc4 : 0,
                  },
                })
              }
            }
          });
          this.filterVehicleLocation = this.filterVehicleLocation.filter((vehLocation)=> this.vehiclesLocation.some((veh)=>veh.vehicleId == vehLocation.vehicleId));
          console.log('mensaje filtrado', this.filterVehicleLocation);
          await this.waitForElm('#map');
          await this.$refs.map.updateVehicleLocation(this.gapi,this.filterVehicleLocation, this.selectedRoute);
        }
      };
    },
    async prepareData() {
      this.isMainPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      this.routes = await this.getRoutes();
      await this.getVehicles();
      [this.assignedRoutes, this.doneRoutes] = await this.routesWithStates();
      if (this.vehiclesLocation) {
        this.filterVehicleLocation = this.vehiclesLocation;
        await this.waitForElm('#map');
        await this.$refs.map.addRealTimeMarkers(this.gapi,this.filterVehicleLocation, true);
      }
      this.isMainPageBussy = false;
      this.autoRefresh();
    },
    async getVehicles(){
      const response = await axios.get(
        `${this.$store.getters.urlAPI}/api/vehicle?light=true&provider=true&requireEnabledSystem=LML&excludeNull=true`,
        {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        },
      );
      if(response.data){
        const vehicles = response.data.data;
        vehicles.forEach((veh)=>{
          if(veh.id_vehicle_operaciones){
            this.vehiclesIds.push(veh.id_vehicle_operaciones);
          }
        })
      }
      if (this.vehiclesIds.length > 0) {
        await this.getHistoryRoute();
        this.sendMessage(this.vehiclesIds.toString());
      }
    },
    async getRoutesFilterDate() {
      if (this.actualDateZone && this.actualChooseDate != this.actualDateZone) {
        this.isMainPageBussy = true;
        this.selectedRoute = null;
        if (this.actualClicked >= 0) {
          await this.$refs.map.cleanMapMarkers();
          await this.$refs.map.cleanMarkersFromSpiderfier();
          await this.$refs.map.setMapNull();
        }
        this.actualClicked = -1;
        this.selectedOperation = null;
        this.isDetailActive = false;
        await this.loadRoutesOps();
        this.isMainPageBussy = false;
      }
    },
    async getRoutes() {
      this.actualChooseDate = this.actualDateZone;
      let start = this.actualChooseDate + ' 00:00:00';
      const startDate = new Date(start).getTime();
      let end = this.actualChooseDate + ' 23:59:59';
      let routes = [];
      const endDate = new Date(end).getTime();
      try {
        const response = await axios.get(
          `${this.$store.getters.urlAPI}/planification?pageSize=-1&startDateFilter=${startDate}&endDateFilter=${endDate}`,
          {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          },
        );
        if (response.data) {
          this.planification = response.data.data;
          this.planification = this.planification.filter(
            (plan) => plan.routesPlan != undefined && plan.routesPlan.length > 0,
          );
          let index = 0;
          this.planification.forEach((plan) => {
            plan.routesPlan.forEach((route) => {
              //Si hay ruta seleccionada, si la ruta es la misma que la seleccionada y ademas si esta ruta seleccionada tiene el colapse activado
              //Entonces le marca el isCollapseClicked como true, para mantener el marcador activo
              if (this.selectedRoute && route.id == this.selectedRoute.id && this.selectedRoute.isCollapseClicked) {
                route.isCollapseClicked = true;
              } else {
                route.isCollapseClicked = false;
              }
              route.index = index;
              index += 1;
            });
            routes.push.apply(routes, plan.routesPlan);
          });
        }
        return routes;
      } catch (e) {
        console.log(e);
      }
    },
    async getDetailRoute(indexRoute, idRoute, idVehicle, totalOp) {
      let url = `${this.$store.getters.urlAPI}/operation?pageNum=0&pageSize=${totalOp}&includeImages=true&excludeDepot=true&includeLocation=true`;
      if (idVehicle) {
        url += `&idVehicle=${idVehicle}`;
      }
      if (idRoute) {
        url += `&idRoute=${idRoute}`;
      }
      try {
        const response = await axios.get(url, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        const operations = response.data.data;
        let done = 0;
        let partiallyDone = 0;
        let rejected = 0;
        operations.forEach((op, index) => {
          op.index = index;
          op.isClicked = false;
          
          op.images = op.relation.images;

          if(this.routes[indexRoute].state == 'NOTENDED'){
            if (op.relation && op.relation.idEvent === 'PREPARING') {
              this.routes[indexRoute].state = 'ONGOING';
              this.selectedRoute.state = 'ONGOING';
            }
          }
          if (op.relation && op.relation.idState === 'DONE') {
            done += 1;
          } else if (op.relation && op.relation.idState === 'PARTIALLYDONE') {
            partiallyDone += 1;
          } else if (op.relation && op.relation.idState === 'REJECTED') {
            rejected += 1;
          }
          op.signatureImageSrc = op.signatureBinary != null ? this.processImageSrc(op.signatureBinary) : null;
          op.isBaseReturn = false;
        });
        this.routes[indexRoute].operationStatistics.done = done;
        this.routes[indexRoute].operationStatistics.partiallyDone = partiallyDone;
        this.routes[indexRoute].operationStatistics.notDoneConfirmed = rejected;
        return operations;
      } catch (e) {
        console.log(e);
      }
    },
    processImageSrc(buffer) {
      return new Uint8Array(buffer);
    },
    async processImage(signatureImageSrc) {
      if (document.getElementById('my-img') != null) {
        let blob = new Blob([signatureImageSrc], { type: 'image/png' } /* (1) */);
        document.getElementById('my-img').src = URL.createObjectURL(blob);
      }
    },
    async loadRoutesOps() {
      this.routes = await this.getRoutes();
      [this.assignedRoutes, this.doneRoutes] = await this.routesWithStates();
      //Como estoy recargando la vista, debo volver a aplicar los filtros
      this.filterRoutesWOChangeCollapse();
      //Si hay una ruta seleccionada entonces actualizo sus operaciones
      if (this.selectedRoute) {
        if(this.selectedRoute.isCollapseClicked){
          //await this.$root.$emit('bv::toggle::collapse', this.selectedRoute.idCollapse);
          this.actualClicked = -1;
          const index = this.selectedRoute.index;
          await this.obtainOperations(index);
          //Si hay operacion seleccionada entonces actualizo sus detalles
          if (this.selectedOperation) {
            this.selectedOperation.isClicked = true;
            this.viewDetails(this.selectedOperation);
          }
        }
      }
    },
    setStatsEmpty() {
      this.globalStats.totalOps = 0;
      this.globalStats.totalOpsDone = 0;
      this.globalStats.totalOpsRejected = 0;
      this.globalStats.totalOpsPending = 0;
      this.globalStats.totalOpsPartially = 0;
    },
    setStatsEmptyFilter() {
      this.globalStats.totalOpsFilter = 0;
      this.globalStats.totalOpsDoneFilter = 0;
      this.globalStats.totalOpsRejectedFilter = 0;
      this.globalStats.totalOpsPendingFilter = 0;
      this.globalStats.totalOpsPartiallyFilter = 0;
    },
    async routesWithStates() {
      let assignedRoutes = [];
      let doneRoutes = [];
      this.setStatsEmpty();
      this.setStatsEmptyFilter();
      this.routes.forEach((route) => {
        this.globalStats.totalOps += route.operationStatistics.total;
        this.globalStats.totalOpsDone += route.operationStatistics.done;
        this.globalStats.totalOpsRejected += route.operationStatistics.notDoneConfirmed;
        this.globalStats.totalOpsPending += route.operationStatistics.notDone;
        this.globalStats.totalOpsPartially += route.operationStatistics.partiallyDone;
        this.globalStats.totalOpsFilter += route.operationStatistics.total;
        this.globalStats.totalOpsDoneFilter += route.operationStatistics.done;
        this.globalStats.totalOpsRejectedFilter += route.operationStatistics.notDoneConfirmed;
        this.globalStats.totalOpsPendingFilter += route.operationStatistics.notDone;
        this.globalStats.totalOpsPartiallyFilter += route.operationStatistics.partiallyDone;
        if (route.state != 'ENDED') {
          if(route.state == 'STARTED' || route.state == 'ONGOING'){
            const veh = this.vehiclesLocation.find((vehLocation)=>vehLocation.vehicleId == route.resources[0].idVehicleOperaciones);
            if(veh){
              veh.state = "ACTIVE";
            }
          }
          assignedRoutes.push(route);
        } else {
          doneRoutes.push(route);
        }
      });
      this.auxRoutesDone = doneRoutes;
      this.auxRoutesAssigned = assignedRoutes;
      return [assignedRoutes, doneRoutes];
    },
    /**
     * Este metodo cierra los colapse abiertos previamente y abre el de la nueva ruta solicitada
     * @param {Route} route
     * @param {idHtml} idCollapse
     * @param {Integer} index
     */
    async toogleCollapse(route, idCollapse, index) {
      this.filterTracking = '';
      if (this.selectedRoute && this.selectedRoute.idCollapse != idCollapse && this.selectedRoute.isCollapseClicked) {
        this.isDetailActive = false;
        this.selectedRoute.isCollapseClicked = !this.selectedRoute.isCollapseClicked;
        await this.$root.$emit('bv::toggle::collapse', this.selectedRoute.idCollapse);
      }
      //Esta variable global se usa para que el estado de cargando se visualice unicamente en la ruta que esta cargando sus operaciones
      this.selectedIdCollapse = idCollapse;
      this.selectedRoute = route;
      this.selectedRoute.index = index;
      this.selectedRoute.idCollapse = idCollapse;
      this.selectedRoute.isCollapseClicked = !this.selectedRoute.isCollapseClicked;
      if (!this.selectedRoute.isCollapseClicked) {
        this.isDetailActive = false;
      }
      await this.$root.$emit('bv::toggle::collapse', idCollapse);
      this.routes[index] = this.selectedRoute;
      this.isRouteBussy = true;
      if(this.selectedRoute.isCollapseClicked){
        await this.obtainOperations(index);
      }
      else{
        //De lo contrario entonces debo mostrar la ubicación de los vehículos
        await this.waitForElm('#map');
        this.$refs.map.addRealTimeMarkers(this.gapi,this.filterVehicleLocation, true);
      }
      this.isRouteBussy = false;
    },
    async obtainOperations(index) {
      this.useGeoFence = false;
      this.operationRoute = await this.getDetailRoute(
        index,
        this.selectedRoute.id,
        this.selectedRoute.resources[0].id,
        this.selectedRoute.operationStatistics.total,
      );
      let haveDepot =
        this.selectedRoute.resources[0].destination.address.lat != this.operationRoute[this.operationRoute.length - 1].spot.address.lat &&
        this.selectedRoute.resources[0].destination.address.lon != this.operationRoute[this.operationRoute.length - 1].spot.address.lon;

        let lastOperation = this.operationRoute[this.operationRoute.length - 1];
        if (haveDepot) {
          //GET DATA del back
          let logResult = await this.getReturnToBaseLog(this.selectedRoute.id,this.selectedRoute.resources[0].idDriver);
          this.operationRoute.push({
            id: -1,
            isClicked: false,
            name: "Retorno a base",
            index: this.operationRoute.length,
            isBase: true,
            address: this.selectedRoute.resources[0].destination.address,
            spot: this.selectedRoute.resources[0].destination,
            relation: {
              startOperationDate: this.operationRoute[this.operationRoute.length - 1].relation.endOperationDate,
              endOperationDate: this.selectedRoute.resources[0].endDate,
              //Aqui poner lo que corresponde segun el servicio
              idState: logResult == null || logResult.idEvent == 1 ? "NOTDONE" : "DONE",
              actualStartOperationDate: this.operationRoute[this.operationRoute.length - 1].relation.endOperationDate,
              actualEndOperationDate: logResult != null ? logResult.sourceDate : null,     
            },
          });
          //seteo la posicion del evento por app
          if (logResult != null) {
            this.selectedRoute.lat = logResult.lat;
            this.selectedRoute.lon = logResult.lon;
          }
        }
      this.renderRouteOnMap(this.selectedRoute, index, lastOperation);
    },
    async getReturnToBaseLog(idRoute,idDriver) {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/routeplan/${idRoute}/driver/${idDriver}/basereturn`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    splitAddress(address) {
      let fullAddress = address.addressComplement
        ? address.street + ', ' + address.addressComplement + ', ' + address.city + ', ' + address.state
        : address.street + ', ' + address.city + ', ' + address.state;
      return fullAddress;
    },
    transformToDate(date) {
      return moment(new Date(date).getTime()).format('HH:mm');
    },
    checkComponentPresence(ref) {
      if (this.$refs[ref] && this.$refs[ref].length > 0) {
        return this.$refs[ref][0].show;
      }
    },
    async viewDetails(operation) {
      if (!this.isDetailPhotoBussy) {
        this.isDetailPhotoBussy = true;
        //Si la operación seleccionada es diferente a la que estaba almacenada entonces se setea el isClicked false si es que es true
        if (this.selectedOperation && this.selectedOperation.id != operation.id) {
          let opClicked = this.operationRoute.find((op) => op.id == this.selectedOperation.id);
          if (opClicked) opClicked.isClicked = false;
        }
        operation.isClicked = true;
        operation.formatedDate = moment(operation.relation.startOperationDate).format(
          'DD [de] MMMM, YYYY. HH:mm [hrs.]',
        );

        let relation = operation.relationDone ? operation.relationDone : operation.relation;
        operation.realEndDate = relation.actualEndOperationDate
          ? moment(relation.actualEndOperationDate).format('DD [de] MMMM, YYYY - HH:mm [hrs.]')
          : null;

        if (!operation.isBase) {
          await this.$refs.map.eventMapClick(operation.index + 1);
        } else {
          //Ejecuto evento especial para buscar base
          await this.$refs.map.eventMapClick(-999);
        }

        this.selectedTrip = operation;
        this.selectedOperation = operation;
        this.isDetailPhotoBussy = false;
      }
      this.isDetailActive = true;
    },
    async toogleVisibilityGeofence(visibilityGeofence) {
      await this.waitForElm('#map');
      await this.$refs.map.setGeofenceVisibility(visibilityGeofence);
    },
    closeDetails() {
      this.isDetailActive = false;
    },
    returnState(state) {
      return this.$t(`trackingPlanification.states.${state}`);
    },
    returnStateOperation(state) {
      return this.$t(`trackingPlanification.statesOperation.${state}`);
    },
    async renderRouteOnMap(route, index, lastOperation) {
      this.actualClicked = index;
      let initSpotList = [];
      let lastSpotList = [];
      let acitivitySpotList = [];

      initSpotList.push({
        index: index,
        spot: route.resources[0].origin,
      });
      //Verifica que el destino de la ruta sea distinto a la ultima operación
      let haveDepot =
        route.resources[0].destination.address.lat != lastOperation.spot.address.lat &&
        route.resources[0].destination.address.lon != lastOperation.spot.address.lon;

      lastSpotList.push({
        index: index,
        spot: haveDepot ? route.resources[0].destination : null,
        lat: haveDepot ? route.lat : null,
        lon: haveDepot ? route.lon : null,
      });
      this.operationRoute.forEach((operation, index2) => {
        if (!operation.isBase) {
          acitivitySpotList.push({
            type: operation.type,
            name: operation.name,
            index: index,
            lat: operation.lat,
            lon: operation.lon,
            subIndex: index2,
            spot: operation.spot,
            state: operation.relation ? operation.relation.idState : 'NOTENDED',
          });
        }
      });
      const resource = route.resources[0];
      let geofence = null;
      if(resource && resource.geofence){
        this.useGeoFence = true;
        this.visibilityGeofence = true;
        geofence = resource.geofence;
      }
      let vehiclePoint = null;
      if(route.state == 'STARTED' || route.state == 'ONGOING'){
        vehiclePoint = this.filterVehicleLocation.find((veh) => resource.idVehicleOperaciones == veh.vehicleId);
        if(vehiclePoint){
          vehiclePoint.state = 'ACTIVE';
        }
      }
      //Prepare map
      await this.waitForElm('#map');
      await this.$refs.map.setSpotsWRoute(this.gapi,initSpotList, acitivitySpotList, lastSpotList, index, geofence, vehiclePoint);
    },
    async getHistoryRoute() {
      const urlHistoryRoute = `${this.$store.getters.urlHistoryRoute}/latest?ignorarFiltros=false&vehicleIds=${this.vehiclesIds.toString()}`;
      try {
        const sendHistoryRoute = await axios.get(urlHistoryRoute,{
          headers: {
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        await this.getDataLatest(sendHistoryRoute.data.data, this.vehiclesIds);
      } catch (e) {
        console.log(e);
      }
    },
    getTotalDistance(route) {
      if (route.totalDistance) {
        return (route.totalDistance / 1000).toFixed(2) + ' Km.';
      }
      return 'N/A';
    },
    getTotalDuration(route) {
      if (route.totalTime) {
        const hour = Math.floor(route.totalTime / 3600);
        const minutes = Math.floor((route.totalTime % 3600) / 60);
        return `${hour}h:${minutes}m`;
      }
      return 'N/A';
    },
    getInitHour(route) {
      if (route.resources && route.resources[0].startDate) {
        const initHour = moment(route.resources[0].startDate).format('HH:mm a');
        return `${initHour}`;
      }
      return 'N/A';
    },
    checkReceiverData() {
      let receiverData = this.selectedOperation.relationDone
        ? this.selectedOperation.relationDone
        : this.selectedOperation.relation;

      let receiverName = receiverData.receiverName;
      let receiverLegalNumber = receiverData.receiverLegalNumber;
      let observation = receiverData.observation;
      let realEndDate = this.selectedOperation.realEndDate;
      let images = this.selectedOperation.images;
      let motive = this.selectedOperation.motive;
      let subMotive = this.selectedOperation.subMotive;
      return receiverName || receiverLegalNumber || observation || realEndDate || images || motive || subMotive;
    },
    /**
     * Metodo que extrae el json de la url entregada, para obteer la data GPS y dibujarla en el mapa
     * @param {String} url
     */
    async getDataLatest(data, listOfIdsVehicle) {
      this.vehiclesLocation = [];

      await listOfIdsVehicle.forEach((idVehicleOp) => {
        let body = {
          vehicleId: null,
          plate: null,
          state: "UNACTIVE",
          gpsData: {
            cog: null,
            battery: 0,
            signal: 0,
            appVersion: ""
          },
          emitedPoint: null,
          lat: null ,
          lon: null,
        };
        const latestVeh = data.find((location)=> location.vehicleId == idVehicleOp);
        if (latestVeh && this.isLatLonValid(latestVeh)) {
          this.validAppVersion(latestVeh);
          body.plate = latestVeh.patente ? latestVeh.patente : latestVeh.plate;
          body.lat= latestVeh.lat;
          body.lon= latestVeh.lon;
          body.emitedPoint = latestVeh.fechaEmision;
          body.gpsData.cog = latestVeh.cog;
          body.gpsData.appVersion = latestVeh.adc >= 0 &&  latestVeh.adc2 >= 0 &&  latestVeh.adc3 >= 0 ? `${latestVeh.adc}.${latestVeh.adc2}.${latestVeh.adc3}` : "1.0.0";
          body.gpsData.battery = latestVeh.bateria != null &&  latestVeh.bateria != undefined && latestVeh.bateria >= 0 ? (latestVeh.bateria*100)/50 : 0;                
          body.gpsData.signal = latestVeh.adc4 != null &&  latestVeh.adc4 != undefined ? latestVeh.adc4 : 0;
          body.vehicleId = latestVeh.vehicleId;

          this.vehiclesLocation.push(body);
        } else {
          console.log('No hay datos');
        }
      });
    },
    validAppVersion(gpsData){
      if(typeof gpsData.adc2 != 'number' || gpsData.adc2 < 0){
        gpsData.adc2 = 0;
      }
      if(typeof gpsData.adc3 != 'number' || gpsData.adc3 < 0){
        gpsData.adc3 = 0;
      }
    },
    isLatLonValid(gpsData){
      return !((gpsData.lat == -1 && gpsData.lon == -1) || (gpsData.lat == 0 && gpsData.lon == 0));
    },
    async waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    },
    startCountDownTimer() {
      this.refreshCountDown = this.refreshCountDownStart;
      this.loadRoutesOps();
      this.autoRefreshTimer = 0;
      this.countDownTimer();
    },
    textToLowerCase(){
      return this.$t('trackingPlanification.suggestion.route').toLowerCase();
    },
    /**@author Jorge Pizarro Tapia
     * Contador que mantiene deshabilitado en boton de refresco de rutas forzado.
     */
    countDownTimer() {
      if (this.refreshCountDown > 0) {
        this.countDownId = setTimeout(() => {
          this.refreshCountDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    openModal(id) {
      this.$bvModal.show(id);
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    openImages() {
      this.selectedOperation.showOnlyImages = true;
      this.selectedOperation.realStartDate = null;
      this.selectedTrip = {
        arrivalDestination: {
          rawReal: null,
          rawSched: null,
        },
        destinationAddress: {
          street: this.selectedOperation.spot.address.street ? this.selectedOperation.spot.address.street : '',
          city: this.selectedOperation.spot.address.city ? this.selectedOperation.spot.address.city : '',
          lat: this.selectedOperation.spot.lat,
          lon: this.selectedOperation.spot.lon,
        },
      };
      this.openModal('operation_images');
      this.showImages = true;
    },
    obtainPercentage(numOps) {
      if (numOps !== undefined && numOps > 0) {
        const percentage = (numOps / this.globalStats.totalOpsFilter) * 100;
        if (percentage < 1) {
          return percentage.toFixed(1);
        } else {
          return Math.round(percentage);
        }
      }
      return 0;
    },
    async filterRoutesWOChangeCollapse(){
      let tempRoutesDone = this.auxRoutesDone;
      let tempRoutesAssigned = this.auxRoutesAssigned;
      let vehiclesIdOps = [];
      if (this.filter != null) {
        this.setStatsEmptyFilter();
        //Filtra todas las rutas asignadas
        tempRoutesAssigned = this.filterStatement(tempRoutesAssigned,vehiclesIdOps);
        //Filtra todas las rutas realizadas
        tempRoutesDone = this.filterStatement(tempRoutesDone,vehiclesIdOps);
      }
      this.doneRoutes = tempRoutesDone;
      this.assignedRoutes = tempRoutesAssigned;
      vehiclesIdOps = [...new Set(vehiclesIdOps)];
      if(this.filter != null && this.filter != ""){
        this.filterVehicleLocation = this.vehiclesLocation.filter((vehLocation)=>vehiclesIdOps.includes(vehLocation.idVehicleOperaciones));
      }else{
        this.filterVehicleLocation = this.vehiclesLocation;
      }
      if(!this.selectedRoute || !this.selectedRoute.isCollapseClicked){
        //De lo contrario entonces debo mostrar la ubicación de los vehículos
        await this.waitForElm('#map');
        await this.$refs.map.addRealTimeMarkers(this.gapi,this.filterVehicleLocation, false);
      }
      this.suggestions = [];
    },
    async filterRoutes() {
      this.setStatsEmptyFilter();
      let tempRoutesDone = this.auxRoutesDone;
      let tempRoutesAssigned = this.auxRoutesAssigned;
      let vehiclesIdOps = [];
      //Si tengo el collapse abierto y el detalle abierto esto se encarga de cerrarlos al filtrar
      if (this.selectedRoute && this.selectedRoute.isCollapseClicked) {
        this.isDetailActive = false;
        this.selectedRoute.isCollapseClicked = !this.selectedRoute.isCollapseClicked;
        this.$root.$emit('bv::toggle::collapse', this.selectedRoute.idCollapse);
      }
      if (this.filter != null) {
        //Filtra todas las rutas asignadas
        tempRoutesAssigned = this.filterStatement(tempRoutesAssigned,vehiclesIdOps);
        //Filtra todas las rutas realizadas
        tempRoutesDone = this.filterStatement(tempRoutesDone,vehiclesIdOps);
      }
      this.doneRoutes = tempRoutesDone;
      this.assignedRoutes = tempRoutesAssigned;
      vehiclesIdOps = [...new Set(vehiclesIdOps)];
      if(this.filter != null && this.filter != ""){
        this.filterVehicleLocation = this.vehiclesLocation.filter((vehLocation)=>vehiclesIdOps.includes(vehLocation.vehicleId));
      }else{
        this.filterVehicleLocation = this.vehiclesLocation;
      }
      if(!this.selectedRoute || !this.selectedRoute.isCollapseClicked){
        //De lo contrario entonces debo mostrar la ubicación de los vehículos
        await this.waitForElm('#map');
        await this.$refs.map.addRealTimeMarkers(this.gapi,this.filterVehicleLocation, true);
      }
      this.cleanSuggestions();
    },
    filterStatement(tempRoutes,vehiclesIdOps){
      return  tempRoutes.filter((route) => {
        const includeName = route.name.toUpperCase().includes(this.filter.toUpperCase());
        const includePlate =
          route.resources[0].plate && route.resources[0].plate.toUpperCase().includes(this.filter.toUpperCase());
        const includeDriver =
          route.resources[0].driverName &&
          route.resources[0].driverName.toUpperCase().includes(this.filter.toUpperCase());
        const status = includeName || includePlate || includeDriver;
        if(route.resources[0] && status){
          vehiclesIdOps.push(route.resources[0].idVehicleOperaciones);
        }
        if (status) {
          this.globalStats.totalOpsFilter += route.operationStatistics.total;
          this.globalStats.totalOpsDoneFilter += route.operationStatistics.done;
          this.globalStats.totalOpsRejectedFilter += route.operationStatistics.notDoneConfirmed;
          this.globalStats.totalOpsPendingFilter += route.operationStatistics.notDone;
          this.globalStats.totalOpsPartiallyFilter += route.operationStatistics.partiallyDone;
        }
        return status;
      });
    },
    cleanSuggestions(){
      this.suggestions = [];
    },
    handleInput() {
      this.suggestions = this.filterSuggestions(this.filter);
      this.filteredSuggestions = {
        routes: [...new Set(this.suggestions.filter(item => item.type === 'routes').map(item => item.value))],
        vehicles: [...new Set(this.suggestions.filter(item => item.type === 'vehicle').map(item => item.value))],
        drivers: [...new Set(this.suggestions.filter(item => item.type === 'driver').map(item => item.value))],
      };
    },
    filterSuggestions(query) {
      if (!query) return [];
      const lowerQuery = query.toLowerCase();
      return this.allRoutes.reduce((acc, item) => {
        if (item.name.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'routes', value: item.name });
        }
        if (item.resources[0] && item.resources[0].plate.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'vehicle', value: item.resources[0].plate });
        }
        if (item.resources[0] && item.resources[0].driverName.toLowerCase().includes(lowerQuery)) {
          acc.push({ type: 'driver', value: item.resources[0].driverName });
        }
        return acc;
      }, []);
    },
    handleSuggestionClick(suggestion) {
      this.filter = suggestion;
      this.filterRoutes();
    },
    cleanFilterRoute(){
      this.filter = "";
      this.filterRoutes();
    },
    formatDate(date, format) {
      //Si date es undefined, quiere decir que el conductor aun no ha empezado/llegado.
      if (date === undefined) {
        return ' -- | -- ';
      }
      return moment(date).format(format);
    },
    autoRefresh() {
      if (this.$route.name !== 'TrackingPlanification') {
        return;
      }
      if (this.autoRefreshTimer <= this.autoRefreshTimerLimit) {
        this.timeoutID = setTimeout(() => {
          this.autoRefreshTimer += 1;
          this.autoRefresh();
        }, 1000);
      } else {
        this.autoRefreshTimer = 0;
        this.loadRoutesOps();
        this.autoRefresh();
      }
    },
    stopUpdating() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
        console.log('Temporizador cancelado');
      }
    },
    stopCountDown(){
      if (this.countDownId !== null) {
        clearTimeout(this.countDownId);
        console.log('Temporizador cancelado');
      }
    },
    closeWebSocket() {
      if (this.socket) {
        this.socket.close(); // Cierra la conexión WebSocket
        console.log('WebSocket cerrado manualmente');
      }
    },
    isResizeRequired() {
      let mayorValue = 0;
      if (this.globalStats.totalOpsFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsFilter;
      }
      if (this.globalStats.totalOpsDoneFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsDoneFilter;
      }
      if (this.globalStats.totalOpsPendingFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsPendingFilter;
      }
      if (this.globalStats.totalOpsRejectedFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsRejectedFilter;
      }
      if (this.globalStats.totalOpsPartiallyFilter > mayorValue) {
        mayorValue = this.globalStats.totalOpsPartiallyFilter;
      }
      return Math.floor(Math.abs(mayorValue)).toString().length > 2;
    },
    async checkOperationDetails(operation) {
      await this.viewDetails(operation);
      if (!operation.isBase) {
        showOperationDetail(operation);
      }
    }
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.selectedOperation != null) {
        this.processImage(this.selectedOperation.signatureImageSrc);
      }
    });
  },
  beforeDestroy() {
    console.log("Deteniendo el intervalo");
    // Detener la actualización cuando el componente se destruya
    this.stopUpdating();
    this.stopCountDown();
    this.closeWebSocket();
  },
  computed: {
    isNewMapEnabled() {
      const feature = this.$feature('newComponent');
      console.log('El nuevo fgeature esta activo ', feature);
      return feature;
    },
    allRoutes() {
      return [...this.assignedRoutes, ...this.doneRoutes];
    },
    actualDateFormat() {
      if (this.$i18n.locale == 'en-US') {
        moment.locale('en');
        return moment(this.actualChooseDate).format('DD [from] MMMM, YYYY');
      } else {
        moment.locale('es-us');
        return moment(this.actualChooseDate).format('DD [de] MMMM, YYYY');
      }
    },
    operationFilter() {
      if (this.filterTracking) {
        return this.operationRoute.filter((item) =>
          item.uuid.toUpperCase().includes(this.filterTracking.toUpperCase()),
        );
      } else {
        return this.operationRoute;
      }
    },
  },
};
